import axios from 'axios';

// Points at the Laravel API. Set REACT_APP_API_URL in frontend/.env before
// running `npm start` / `npm run build` (e.g. https://pixnest.backend.test/api
// locally via Herd, https://api.pixnest.in/api in prod) — edit .env directly
// for each environment rather than relying on a separate .env.production.
const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: BACKEND_URL,
  headers: { Accept: 'application/json' },
});

// Attach the Sanctum bearer token, if present, to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pixnest_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear the stale token so the UI can redirect to /auth.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pixnest_token');
    }
    return Promise.reject(error);
  }
);

export const auth = {
  register: (payload) => api.post('/auth/register', payload),
  login: (payload) => api.post('/auth/login', payload),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
};

export const photographers = {
  list: (params) => api.get('/photographers', { params }),
  get: (id) => api.get(`/photographers/${id}`),
  update: (id, payload) => api.put(`/photographers/${id}`, payload),
};

export const services = {
  list: () => api.get('/services'),
  create: (payload) => api.post('/services', payload),
  update: (id, payload) => api.put(`/services/${id}`, payload),
  remove: (id) => api.delete(`/services/${id}`),
};

export const bookings = {
  list: () => api.get('/bookings'),
  create: (payload) => api.post('/bookings', payload),
  get: (id) => api.get(`/bookings/${id}`),
  updateStatus: (id, status) => api.patch(`/bookings/${id}/status`, { status }),
};

export const assets = {
  list: (bookingId) => api.get(`/bookings/${bookingId}/assets`),
  upload: (bookingId, formData) =>
    api.post(`/bookings/${bookingId}/assets`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  download: (assetId) => api.get(`/assets/${assetId}/download`),
  remove: (assetId) => api.delete(`/assets/${assetId}`),
};

export const shares = {
  create: (bookingId, payload) => api.post(`/bookings/${bookingId}/shares`, payload),
  view: (token, password) => api.get(`/gallery/${token}`, { params: { password } }),
  download: (token, assetId, password) =>
    api.get(`/gallery/${token}/assets/${assetId}/download`, { params: { password } }),
};

export const reviews = {
  create: (bookingId, payload) => api.post(`/bookings/${bookingId}/review`, payload),
};

export default api;
